__turbopack_context__.v({
  "ratings": "JVPQAa_ratings",
});
